import { useRef } from "react";
import { X } from "lucide-react";
import { SHORTCUT_GROUPS, useFocusTrap } from "../lib/shortcuts";
import Kbd from "./Kbd";

// Aide des raccourcis, ouverte par « ? ».
export default function ShortcutsHelp({ open, onClose, groups = SHORTCUT_GROUPS }) {
  const panel = useRef(null);
  useFocusTrap(panel, open);
  if (!open) return null;

  return (
    <div
      className="adm-dialog-backdrop"
      onMouseDown={e => { if (e.target === e.currentTarget) onClose?.(); }}
      onKeyDown={e => { if (e.key === "Escape") { e.stopPropagation(); e.preventDefault(); onClose?.(); } }}
    >
      <div
        ref={panel}
        className="adm-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="shortcuts-title"
        style={{ width: "min(620px, 100%)" }}
        tabIndex={-1}
        data-testid="shortcuts-help"
      >
        <div className="adm-dialog-head">
          <div style={{ flex: 1 }}>
            <h2 id="shortcuts-title">Raccourcis clavier</h2>
            <p>La console se pilote au clavier : ces raccourcis fonctionnent partout, sauf quand le curseur est dans un champ de saisie.</p>
          </div>
          <button type="button" className="adm-btn is-ghost is-icon" onClick={onClose} aria-label="Fermer" data-testid="shortcuts-close">
            <X size={15} />
          </button>
        </div>

        <div className="adm-dialog-body" style={{ paddingBottom: 18 }}>
          <div className="adm-shortcuts">
            {groups.map(group => (
              <section key={group.title}>
                <h3>{group.title}</h3>
                <dl>
                  {group.items.map(item => (
                    <div className="adm-shortcut-row" key={item.label}>
                      <dt>{item.label}</dt>
                      <dd><Kbd keys={item.keys} sep={item.keys[0] === "g" ? "puis" : undefined} /></dd>
                    </div>
                  ))}
                </dl>
              </section>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
